export const SIDEBAR_COOKIE_NAME = 'sidebar_state';
export const SIDEBAR_COOKIE_MAX_AGE = 60 * 60 * 24 * 7;
// 13rem = 208px. Narrowed from 16rem/256px: the global nav holds 7 short
// labels and 3 utility links, none of which came close to filling 256px, while
// the content column beneath it was ellipsising real record data (contact
// emails, "Preferred solicitor", "Death certificate"). Snapped to a multiple of
// 8 to stay on the spacing scale. Don't go below ~12rem — "Getting Started" and
// "Contact Support" start truncating.
export const SIDEBAR_WIDTH = '13rem';
export const SIDEBAR_WIDTH_MOBILE = '18rem';
export const SIDEBAR_WIDTH_ICON = '3rem';
export const SIDEBAR_KEYBOARD_SHORTCUT = 'b';
// Viewport width below which the global nav auto-collapses into the mobile
// drawer. Tailwind's `lg` (1024px) — the desktop/tablet boundary — so the nav
// stays expanded at normal desktop/laptop widths and only collapses on
// genuinely narrow tablet-portrait / mobile screens. MUST stay in sync with
// the `lg:` responsive classes in sidebar.tsx.
export const SIDEBAR_COLLAPSE_BREAKPOINT = 1024;
